import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { GSalesReportByDate } from 'src/app/viewmodels/g-settings/GSalesReportByDate';
import { JqHelper } from "src/app/common/jq-helper";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppConsts } from 'src/app/common/app-consts';
import { ItemCodeModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sales-reports-by-date',
  templateUrl: './sales-reports-by-date.component.html',
  styleUrls: ['./sales-reports-by-date.component.scss']
})
export class SalesReportsByDateComponent implements OnInit {
  public component_Title = 'Sales Report';
  public customerDetail: any = [];
  public selectedcustomerDetail: any = [];
  public SalesReportByDate = new GSalesReportByDate();

  public fromDate: Date;
  public toDate: Date;
  public customer: ItemViewModel1 = new ItemViewModel1();

  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "accTitle",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    limitSelection: 1,
  };

  constructor(private _jq: JqHelper, private _uow: UnitOfWorkService, private spinner: NgxSpinnerService,
  ) {
    // this.SalesReportByDate.StartDate = new Date();
    // this.SalesReportByDate.EndDate = new Date();
  }

  ngOnInit() {
    this.getCustomerName();
  }

  getCustomerName() {
    debugger;
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.CUSTOMER).subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.result.map(x => {
          return {
            id: x.id, // or the actual ID field
            accTitle: x.accCode + '-' + x.accTitle // concatenated name and code
          };
        });

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }



  getDates() {
    debugger
    if (this.fromDate > this.toDate) {
      console.log("date error");
    } else {
      this.spinner.show();
      this._uow.gReportingService.GetGSaleReportAsync(this.customer[0].id, this.fromDate.toISOString(), this.toDate.toISOString()).subscribe((res: any) => {
        debugger
        this.spinner.hide();
        this.openLinkInNewTab(res.file);
      }, err => {
        debugger
        Swal.fire("Error!", "No Data Found!", "error");
        this.spinner.hide();
      })
    }
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }

}
